import {Dialog, DialogActions, DialogContent, DialogContentText} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import {FuelType} from "../../utils/model/FuelType";
import {Station} from "../../utils/model/Station";

interface Props {
    station: Station,
    fuelType: FuelType,
    onValidate(e: React.MouseEvent<HTMLElement>, stationId: string, fuelType: FuelType): void,
    onClose(): void
}

export default function ValidateDeleteFuelAdminDialog({station, fuelType, onValidate, onClose}: Props) {
    return (
        <Dialog
            open={true}
            onClose={onClose}
            className='dialog'>
            <DialogContent>
                <DialogContentText>
                    {"Are you sure to delete " + fuelType + " for this station?"}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="secondary" onClick={(e) => onValidate(e, station.id, fuelType)}>Yes</Button>
                <Button variant="contained" color="secondary" onClick={onClose}>No</Button>
            </DialogActions>
        </Dialog>
    )
}